import { Checkbox } from "@mui/material";
import React from "react";

import { useWorkOrdersContext } from "../../hooks";

const WorkOrdersCheckbox = ({ item }) => {
  const { onSelect = () => {}, ids } = useWorkOrdersContext();

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onSelect(item?.workOrder);
  };

  return (
    <Checkbox
      sx={{ padding: 0 }}
      checked={ids.has(item?.workOrder)}
      onClick={handleClick}
    />
  );
};

export default WorkOrdersCheckbox;
